import { useNavigate } from "react-router-dom";
import useUserStore from "../store/userStore";
import useLogin from "../hooks/useLogin";
import { useForm } from "react-hook-form";
import { z } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";
import UserLogin from "../interfaces/userLogin";
import { useEffect } from "react";

const LoginForm = () => {
  const schema = z.object({
    username: z.string().min(1, { message: "Username is required" }),
    password: z.string().min(1, { message: "Password is required" }),
  });

  const token = useUserStore((state) => state.token);
  const destinyRoute = useUserStore((state) => state.destinyRoute);
  const setToken = useUserStore((state) => state.setToken);

  const navigate = useNavigate();

  const { mutate: login, error: loginError } = useLogin();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<z.infer<typeof schema>>({ resolver: zodResolver(schema) });

  const submitLogin = ({ username, password }: UserLogin) => {
    const user: UserLogin = { username, password };
    login(user, {
      onSuccess: (data) => {
        if (data.token) {
          setToken(data);
          localStorage.setItem("token", data.token);
          navigate(destinyRoute);
        } else {
          setToken({ token: "", username: "", isAdmin: false });
        }
      },
      onError: () => {
        setToken({ token: "", username: "", isAdmin: false });
      },
    });
  };

  useEffect(() => {
    if (token) {
      navigate(destinyRoute);
    }
  }, [token, navigate, destinyRoute]);

  return (
    <div className="d-flex align-items-center justify-content-center" style={{ minHeight: 'calc(100vh - 56px)', backgroundColor: '#1d1f1c', color: '#c2c2c2', paddingTop: '56px' }}>
      <div className="col-md-6 col-lg-4">
        <div className="card p-4 shadow-lg" style={{ backgroundColor: '#2a2d2a', border: '1px solid #3c403c' }}>
          <h2 className="text-center mb-4" style={{ color: '#e0e0e0' }}>Login</h2>
          {loginError && (
            <div className="alert alert-danger fw-bold text-center" role="alert" style={{ backgroundColor: '#4a2c2c', borderColor: '#6a3c3c', color: '#ffdddd' }}>
              Invalid username or password.
            </div>
          )}
          <form onSubmit={handleSubmit(submitLogin)}>
            <div className="mb-3">
              <label htmlFor="username" className="form-label">
                Username
              </label>
              <input
                type="text"
                id="username"
                {...register("username")}
                className={`form-control ${errors.username ? "is-invalid" : ""}`}
                style={{ backgroundColor: '#333633', color: '#c2c2c2', borderColor: '#4a4d4a' }}
              />
              <div className="invalid-feedback" style={{ color: '#ff8888' }}>
                {errors.username?.message}
              </div>
            </div>
            <div className="mb-4">
              <label htmlFor="password" className="form-label">
                Password
              </label>
              <input
                type="password"
                id="password"
                {...register("password")}
                className={`form-control ${errors.password ? "is-invalid" : ""}`}
                style={{ backgroundColor: '#333633', color: '#c2c2c2', borderColor: '#4a4d4a' }}
              />
              <div className="invalid-feedback" style={{ color: '#ff8888' }}>
                {errors.password?.message}
              </div>
            </div>
            <div className="d-grid gap-2 mb-3">
              <button type="submit" className="btn btn-primary" style={{ backgroundColor: '#5cb85c', borderColor: '#5cb85c', color: '#1d1f1c' }}>
                Login
              </button>
            </div>
          </form>
          <div className="text-center mt-3">
            Don't have an account yet?{" "}
            <a href="/register" style={{ color: '#66bb6a', textDecoration: 'none' }}> {/* Green link for visibility */}
              Register
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginForm;